import { TextBadge } from '@carvana/ds-badge';
import { TrackClick } from '@carvana/merch-components';
import { SectionId } from '~/constants/vdp/section';
import SubSections from '~/constants/vdp/subSections';
import { useIsMobile } from '~/context/common/DeviceContext';
import { useSectionAnalytics } from '~/context/vdp/SectionAnalyticsContext';
import { usePriceDrop } from '~/hooks/vdp';

export default function PriceDropBadge() {
  const isMobile = useIsMobile();
  const { analyticsAttributes, analyticsId } = useSectionAnalytics();
  const { isPriceDropRestrictedState } = usePriceDrop();
  const badgeText = isPriceDropRestrictedState ? 'New Price' : 'Price Drop';

  return (
    <TrackClick
      className="pointer-events-auto"
      element="a"
      data-adobe-id="price-drop-badge"
      data-analytics-id={analyticsId}
      data-analytics-attributes={{
        ...analyticsAttributes,
        description: 'badge',
        text: badgeText
      }}
      data-testid="new-price-badge"
      href={
        isMobile ? `#${SubSections.NewPrice}` : `#${SectionId.AboutThePrice}`
      }
    >
      <TextBadge priority="success">{badgeText}</TextBadge>
    </TrackClick>
  );
}
